import Funnel from '../funnel/funnel.jsx';
import { useEffect } from 'react';

const SessionStorageJS = () => {
    useEffect(()=>{
        window.sessionStorage.setItem('cartValue', "£"+Math.floor(Math.random() * (10000 - 100) + 100) / 100)

    },[])
  return (
    <div style={{ textAlign: 'left' }}>
      <h1>JavaScript: Session Storage</h1>
      <p>The user's cart value during the checkout steps below is stored in the browser session storage, and not visible in the UI the user sees.</p>
      <p>Using the JavaScript editor on the right, retrieve the current cart value from Session Storage and console log the current value.</p>
      <Funnel defaultStep={1} errorState={false}/>
    </div>
  )

}

export default SessionStorageJS;